import BuildIcon from '@material-ui/icons/Build';
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const releasePipelinesPage = PageBlueprint.make({
  name: 'release-pipelines',
  params: {
    path: '/release-pipelines',
    title: 'Release Pipelines',
    icon: <BuildIcon fontSize="inherit" />,
    loader: () =>
      import('./ReleasePipelinesPage').then(m => <m.ReleasePipelinesPage />),
  },
});

const entityReleasePipelinesContent = EntityContentBlueprint.make({
  name: 'release-pipelines',
  params: {
    path: '/release-pipelines',
    title: 'Release Pipelines',
    group: 'deployment',
    icon: <BuildIcon fontSize="inherit" />,
    loader: () =>
      import('./EntityReleasePipelinesContent').then(
        m => <m.EntityReleasePipelinesContent />,
      ),
    filter: entity =>
      Boolean(
        entity.metadata.annotations?.['dev.azure.com/project-repo'] ||
          entity.metadata.annotations?.['dev.azure.com/project'],
      ),
  },
});

export const releasePipelinesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [releasePipelinesPage, entityReleasePipelinesContent],
});
